import React, {CSSProperties} from 'react';

interface LinkifyProps {
    text: string;
    linkAtStartOnly?: boolean;
    className?: string;
    style?: CSSProperties;
}

const Linkify: React.FC<LinkifyProps> = ({ text, linkAtStartOnly=false ,className,style}) => {
    // Regular expressions to find URLs
    if(!text) return (<div></div>);
    const urlPattern = linkAtStartOnly ? /^(https?:\/\/[^\s]+)/ : /(https?:\/\/[^\s]+)/g;
    const handleLinkClick = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        // Prevents the click event from propagating up to parent elements
        event.stopPropagation();
    };
    // Function to replace URLs in text with anchor tags
    const replaceLink = (match: string, offset: number): JSX.Element | string => {
        if (linkAtStartOnly && offset !== 0) {
            return match;
        }

        return <a onClick={handleLinkClick} href={match} target="_blank" rel="noopener noreferrer"><b>{match}</b></a>;
    };

    // Splitting the text and replacing URLs with React elements
    const content = text.split(urlPattern).map((part, index) => {
        if (part.match(urlPattern)) {
            return replaceLink(part, index);
        }
        return part;
    });

    return <div className={className} style={style}>{content}</div>;
};

export default Linkify;
